// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================================================================
   USER ACCOUNT — dashboard · bookings · profile
   ================================================================ */

.ua-page {
  background: var(--bv-bg-cream);
  min-height: calc(100vh - 72px);
  padding: var(--bv-space-6) 0 var(--bv-space-10);
  font-family: var(--bv-font-body);
  color: var(--bv-ink-2);
  width: 100%;
  overflow-x: clip;
}

.ua-shell {
  display: grid;
  grid-template-columns: 260px minmax(0, 1fr);
  gap: var(--bv-space-6);
  align-items: start;
  width: 100%;
  min-width: 0;
}

/* —— Sidebar —— */
.ua-sidebar {
  position: sticky;
  top: calc(72px + var(--bv-space-4));
  display: flex;
  flex-direction: column;
  gap: var(--bv-space-4);
  padding: var(--bv-space-4);
  border-radius: var(--bv-radius-xl);
  background: #fff;
  border: 1px solid var(--bv-line-soft);
  box-shadow: var(--bv-shadow-sm);
}

.ua-sidebar__profile {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: var(--bv-space-3);
  border-radius: var(--bv-radius-lg);
  background: var(--bv-bg-soft);
  border: 1px solid var(--bv-line-soft);
}

.ua-sidebar__avatar {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bv-grad-primary);
  color: #fff;
  font-family: var(--bv-font-display);
  font-size: var(--bv-text-sm);
  font-weight: 700;
}

.ua-sidebar__avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.ua-sidebar__meta {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.ua-sidebar__meta strong {
  font-size: var(--bv-text-sm);
  font-weight: 700;
  color: var(--bv-ink);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ua-sidebar__meta span {
  font-size: var(--bv-text-xs);
  color: var(--bv-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ua-nav {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.ua-nav__link {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px 14px;
  border-radius: var(--bv-radius);
  border: 1px solid transparent;
  color: var(--bv-ink-2);
  font-size: var(--bv-text-sm);
  font-weight: 600;
  text-decoration: none;
  transition:
    background var(--bv-dur) var(--bv-ease),
    border-color var(--bv-dur) var(--bv-ease),
    color var(--bv-dur) var(--bv-ease);
}

.ua-nav__link i:first-child {
  width: 18px;
  text-align: center;
  color: var(--bv-primary);
  font-size: 0.9rem;
}

.ua-nav__chevron {
  margin-left: auto;
  font-size: 0.65rem;
  color: var(--bv-primary-700);
  opacity: 0.7;
}

.ua-nav__link:hover {
  border-color: var(--bv-primary-line);
  color: var(--bv-primary-800);
}

.ua-nav__link.is-active {
  background: var(--bv-primary-50);
  border-color: var(--bv-primary-line);
  color: var(--bv-primary-800);
  box-shadow: var(--bv-shadow-xs);
}

.ua-nav__link--accent {
  margin-top: 4px;
  background: var(--bv-grad-primary);
  color: #fff;
  box-shadow: var(--bv-shadow-teal);
}

.ua-nav__link--accent i:first-child {
  color: #fff;
}

.ua-nav__link--accent:hover {
  color: #fff;
  transform: translateY(-1px);
}

/* —— Main content —— */
.ua-main {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: var(--bv-space-5);
}

.ua-main__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--bv-space-4);
  flex-wrap: wrap;
}

.ua-main__titles h1 {
  margin: 0 0 6px;
  font-family: var(--bv-font-display);
  font-size: var(--bv-text-2xl);
  font-weight: 800;
  letter-spacing: -0.03em;
  color: var(--bv-ink);
  line-height: 1.15;
}

.ua-main__titles p {
  margin: 0;
  font-size: var(--bv-text-sm);
  color: var(--bv-muted);
  line-height: 1.5;
}

.ua-main__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.ua-main__body {
  display: flex;
  flex-direction: column;
  gap: var(--bv-space-5);
}

/* —— Cards & panels —— */
.ua-card {
  padding: var(--bv-space-5);
  border-radius: var(--bv-radius-xl);
  background: #fff;
  border: 1px solid var(--bv-line-soft);
  box-shadow: var(--bv-shadow-xs);
}

.ua-card__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: var(--bv-space-4);
  padding-bottom: var(--bv-space-3);
  border-bottom: 1px solid var(--bv-line-soft);
}

.ua-card__head h2 {
  margin: 0 0 4px;
  font-family: var(--bv-font-display);
  font-size: var(--bv-text-lg);
  font-weight: 800;
  color: var(--bv-ink);
  letter-spacing: -0.02em;
}

.ua-card__head p {
  margin: 0;
  font-size: var(--bv-text-sm);
  color: var(--bv-muted);
}

/* —— Stats grid —— */
.ua-stats {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--bv-space-4);
}

.ua-stat {
  display: flex;
  align-items: center;
  gap: var(--bv-space-4);
  padding: var(--bv-space-4);
  border-radius: var(--bv-radius-lg);
  background: var(--bv-bg-soft);
  border: 1px solid var(--bv-line-soft);
}

.ua-stat__body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ua-stat__label {
  display: block;
  font-size: var(--bv-text-xs);
  font-weight: 600;
  color: var(--bv-muted);
  margin-bottom: 4px;
}

.ua-stat__value {
  display: block;
  font-family: var(--bv-font-display);
  font-size: var(--bv-text-xl);
  font-weight: 800;
  color: var(--bv-primary-800);
  letter-spacing: -0.02em;
  line-height: 1.1;
}

.ua-stat__icon {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: var(--bv-radius);
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bv-primary-50);
  border: 1px solid var(--bv-primary-line);
  color: var(--bv-primary-700);
  font-size: 1.1rem;
}

/* —— Filter tabs —— */
.ua-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 4px;
  border-radius: var(--bv-radius-lg);
  background: var(--bv-bg-soft);
  border: 1px solid var(--bv-line-soft);
}

.ua-filter {
  flex: 1 1 auto;
  min-width: fit-content;
  padding: 9px 16px;
  border: 1px solid transparent;
  border-radius: var(--bv-radius);
  background: transparent;
  color: var(--bv-muted);
  font-family: var(--bv-font-body);
  font-size: var(--bv-text-sm);
  font-weight: 600;
  cursor: pointer;
  transition:
    background var(--bv-dur) var(--bv-ease),
    border-color var(--bv-dur) var(--bv-ease),
    color var(--bv-dur) var(--bv-ease);
}

.ua-filter:hover {
  color: var(--bv-primary-800);
  background: #fff;
}

.ua-filter.is-active {
  background: #fff;
  border-color: var(--bv-primary-line);
  color: var(--bv-primary-800);
  box-shadow: var(--bv-shadow-xs);
}

/* —— Booking list —— */
.ua-bookings {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ua-booking {
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 14px;
  align-items: center;
  padding: var(--bv-space-4);
  border-radius: var(--bv-radius-lg);
  background: var(--bv-bg-soft);
  border: 1px solid var(--bv-line-soft);
  transition:
    border-color var(--bv-dur) var(--bv-ease),
    box-shadow var(--bv-dur) var(--bv-ease);
}

.ua-booking:hover {
  border-color: var(--bv-primary-line);
  box-shadow: var(--bv-shadow-xs);
}

.ua-booking__media {
  width: 56px;
  height: 56px;
  border-radius: var(--bv-radius);
  overflow: hidden;
  flex-shrink: 0;
  background: #fff;
  border: 1px solid var(--bv-line-soft);
}

.ua-booking__media img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.ua-booking__media--placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--bv-primary);
  font-size: 1.25rem;
}

.ua-booking__body {
  min-width: 0;
}

.ua-booking__title {
  margin: 0 0 6px;
  font-size: var(--bv-text-sm);
  font-weight: 700;
  color: var(--bv-ink);
  line-height: 1.3;
}

.ua-booking__court {
  font-weight: 600;
  color: var(--bv-muted);
}

.ua-booking__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 14px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.ua-booking__meta li {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: var(--bv-text-xs);
  color: var(--bv-muted);
  font-weight: 500;
}

.ua-booking__meta i {
  color: var(--bv-primary);
  font-size: 0.7rem;
}

.ua-booking__aside {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  flex-shrink: 0;
}

.ua-booking__price {
  font-family: var(--bv-font-display);
  font-size: var(--bv-text-base);
  font-weight: 800;
  color: var(--bv-primary-800);
  white-space: nowrap;
}

/* —— Status badge —— */
.ua-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 10px;
  border-radius: var(--bv-radius-pill);
  font-size: var(--bv-text-xs);
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
}

.ua-badge--success {
  background: #ecfdf5;
  color: #047857;
  border: 1px solid #a7f3d0;
}

.ua-badge--warning {
  background: #fffbeb;
  color: #b45309;
  border: 1px solid #fde68a;
}

.ua-badge--danger {
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

.ua-badge--muted {
  background: var(--bv-bg-soft);
  color: var(--bv-muted);
  border: 1px solid var(--bv-line);
}

/* —— Buttons —— */
.ua-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 18px;
  border-radius: var(--bv-radius-pill);
  border: 1px solid transparent;
  font-family: var(--bv-font-display);
  font-size: var(--bv-text-sm);
  font-weight: 600;
  cursor: pointer;
  transition:
    transform var(--bv-dur) var(--bv-ease),
    box-shadow var(--bv-dur) var(--bv-ease),
    background var(--bv-dur) var(--bv-ease);
  text-decoration: none;
  line-height: 1;
}

.ua-btn--primary {
  background: var(--bv-grad-primary);
  color: #fff;
  box-shadow: var(--bv-shadow-teal);
}

.ua-btn--primary:hover:not(:disabled) {
  transform: translateY(-1px);
  color: #fff;
}

.ua-btn--ghost {
  background: #fff;
  border-color: var(--bv-line);
  color: var(--bv-ink-2);
}

.ua-btn--ghost:hover:not(:disabled) {
  border-color: var(--bv-primary-line);
  color: var(--bv-primary-800);
}

.ua-btn--danger {
  background: #fff;
  border-color: #fecaca;
  color: #b91c1c;
}

.ua-btn--danger:hover:not(:disabled) {
  background: #fef2f2;
}

.ua-btn--sm {
  padding: 7px 14px;
  font-size: var(--bv-text-xs);
}

.ua-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

/* —— Empty state —— */
.ua-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: var(--bv-space-8) var(--bv-space-4);
  text-align: center;
  border-radius: var(--bv-radius-lg);
  background: var(--bv-bg-soft);
  border: 1px dashed var(--bv-line);
}

.ua-empty__icon {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bv-primary-50);
  border: 1px solid var(--bv-primary-line);
  color: var(--bv-primary);
  font-size: 1.25rem;
}

.ua-empty h3 {
  margin: 0;
  font-size: var(--bv-text-base);
  font-weight: 700;
  color: var(--bv-ink);
}

.ua-empty p {
  margin: 0;
  max-width: 36ch;
  font-size: var(--bv-text-sm);
  color: var(--bv-muted);
  line-height: 1.5;
}

/* —— Pagination —— */
.ua-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding-top: var(--bv-space-3);
  border-top: 1px solid var(--bv-line-soft);
}

.ua-pagination__size {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: var(--bv-text-sm);
  color: var(--bv-muted);
  font-weight: 500;
}

.ua-pagination__size select {
  padding: 7px 12px;
  border-radius: var(--bv-radius);
  border: 1px solid var(--bv-line);
  background: #fff;
  font-family: var(--bv-font-body);
  font-size: var(--bv-text-sm);
  color: var(--bv-ink-2);
}

.ua-pagination__nav {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ua-pagination__page {
  min-width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--bv-grad-primary);
  color: #fff;
  font-size: var(--bv-text-sm);
  font-weight: 700;
}

.ua-pagination__btn {
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid var(--bv-line);
  background: #fff;
  color: var(--bv-ink-2);
  cursor: pointer;
  transition: border-color var(--bv-dur) var(--bv-ease);
}

.ua-pagination__btn:hover:not(:disabled) {
  border-color: var(--bv-primary-line);
  color: var(--bv-primary-800);
}

.ua-pagination__btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* —— Profile form —— */
.ua-profile {
  display: grid;
  grid-template-columns: 200px minmax(0, 1fr);
  gap: var(--bv-space-6);
}

.ua-avatar-upload {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: var(--bv-space-4);
  border-radius: var(--bv-radius-lg);
  background: var(--bv-bg-soft);
  border: 1px dashed var(--bv-line);
  cursor: pointer;
  transition:
    border-color var(--bv-dur) var(--bv-ease),
    background var(--bv-dur) var(--bv-ease);
}

.ua-avatar-upload:hover {
  border-color: var(--bv-primary-line);
  background: var(--bv-primary-50);
}

.ua-avatar-upload__preview {
  width: 112px;
  height: 112px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 2px solid var(--bv-primary-line);
  color: var(--bv-primary);
  font-size: 2rem;
}

.ua-avatar-upload__preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.ua-avatar-upload__hint {
  margin: 0;
  font-size: var(--bv-text-xs);
  font-weight: 600;
  color: var(--bv-muted);
  text-align: center;
}

.ua-form-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--bv-space-4);
}

.ua-form-grid--full {
  grid-column: 1 / -1;
}

.ua-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.ua-field label {
  font-size: var(--bv-text-xs);
  font-weight: 700;
  color: var(--bv-ink-2);
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.ua-field input {
  width: 100%;
  padding: 11px 14px;
  border-radius: var(--bv-radius);
  border: 1px solid var(--bv-line);
  background: #fff;
  font-family: var(--bv-font-body);
  font-size: var(--bv-text-sm);
  color: var(--bv-ink);
  transition:
    border-color var(--bv-dur) var(--bv-ease),
    box-shadow var(--bv-dur) var(--bv-ease);
}

.ua-field input:focus {
  outline: none;
  border-color: var(--bv-primary);
  box-shadow: 0 0 0 3px var(--bv-primary-50);
}

.ua-field input:disabled {
  background: var(--bv-bg-soft);
  color: var(--bv-muted);
  cursor: not-allowed;
}

.ua-field__error {
  margin: 0;
  font-size: var(--bv-text-xs);
  color: var(--bv-danger);
  font-weight: 500;
}

.ua-form-section {
  grid-column: 1 / -1;
  margin-top: var(--bv-space-2);
  padding-top: var(--bv-space-4);
  border-top: 1px solid var(--bv-line-soft);
}

.ua-form-section h3 {
  margin: 0 0 var(--bv-space-4);
  font-family: var(--bv-font-display);
  font-size: var(--bv-text-base);
  font-weight: 800;
  color: var(--bv-ink);
}

.ua-form-actions {
  grid-column: 1 / -1;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 10px;
  padding-top: var(--bv-space-4);
  border-top: 1px solid var(--bv-line-soft);
}

.ua-profile .react-select__control {
  min-height: 44px !important;
  border-radius: var(--bv-radius) !important;
  border-color: var(--bv-line) !important;
  background: #fff !important;
  font-size: var(--bv-text-sm) !important;
  box-shadow: none !important;
}

.ua-profile .react-select__control--is-focused {
  border-color: var(--bv-primary) !important;
  box-shadow: 0 0 0 3px var(--bv-primary-50) !important;
}

.ua-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: var(--bv-space-10);
  color: var(--bv-muted);
  font-size: var(--bv-text-sm);
  font-weight: 500;
}

/* —— Responsive —— */
@media (max-width: 1199px) {
  .ua-form-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 991px) {
  .ua-page {
    padding: var(--bv-space-4) 0 var(--bv-space-7);
    font-size: 0.875rem;
    min-height: calc(100vh - 64px);
  }

  .ua-shell {
    grid-template-columns: 1fr;
    gap: var(--bv-space-3);
    padding-inline: 0;
  }

  .ua-sidebar {
    position: static;
    min-height: 0;
    max-width: 100%;
    overflow: hidden;
    padding: var(--bv-space-2);
    gap: 0;
    border-radius: var(--bv-radius-lg);
    box-shadow: var(--bv-shadow-xs);
  }

  .ua-nav {
    flex: unset;
    flex-direction: row;
    flex-wrap: nowrap;
    overflow-x: auto;
    scrollbar-width: none;
    -webkit-overflow-scrolling: touch;
    gap: 6px;
    max-width: 100%;
    padding-bottom: 2px;
  }

  .ua-nav::-webkit-scrollbar {
    display: none;
  }

  .ua-nav__link {
    flex: 0 0 auto;
    white-space: nowrap;
    padding: 9px 12px;
    font-size: 0.8125rem;
    gap: 7px;
    border-radius: var(--bv-radius-pill);
  }

  .ua-nav__link i:first-child {
    font-size: 0.78rem;
    width: 14px;
  }

  .ua-nav__chevron {
    display: none;
  }

  .ua-nav__link--accent {
    margin-top: 0;
    padding-top: 9px;
  }

  .ua-sidebar__profile {
    display: none;
  }

  .ua-main {
    gap: var(--bv-space-3);
  }

  .ua-main__head {
    flex-direction: column;
    align-items: stretch;
    gap: var(--bv-space-3);
    padding: var(--bv-space-2) var(--bv-space-3) var(--bv-space-4);
  }

  .ua-main__titles h1 {
    font-size: 1.25rem;
    margin-bottom: 4px;
  }

  .ua-main__titles p {
    font-size: 0.8125rem;
    line-height: 1.45;
  }

  .ua-main__actions {
    width: 100%;
  }

  .ua-main__actions .ua-btn {
    width: auto;
    max-width: 100%;
    align-self: flex-start;
  }

  .ua-main__body {
    gap: var(--bv-space-3);
  }

  .ua-stats {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: var(--bv-space-3);
  }

  .ua-stat {
    padding: var(--bv-space-3);
    gap: 10px;
    align-items: center;
  }

  .ua-stat__body {
    gap: 2px;
  }

  .ua-stat__icon {
    width: 40px;
    height: 40px;
    font-size: 0.95rem;
    flex-shrink: 0;
  }

  .ua-stat__value {
    font-size: 1.25rem;
  }

  .ua-stat__label {
    font-size: 0.6875rem;
  }

  .ua-card {
    padding: var(--bv-space-4);
    border-radius: var(--bv-radius-lg);
  }

  .ua-card__head {
    margin-bottom: var(--bv-space-3);
    padding-bottom: var(--bv-space-2);
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  .ua-card__head .ua-btn {
    width: auto;
    max-width: 100%;
    align-self: flex-start;
    justify-content: center;
  }

  .ua-card__head h2 {
    font-size: 1rem;
  }

  .ua-card__head p {
    font-size: 0.8125rem;
  }

  .ua-filters {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 6px;
    padding: 4px;
  }

  .ua-filter {
    flex: unset;
    width: 100%;
    min-width: 0;
    text-align: center;
    padding: 8px 10px;
    font-size: 0.8125rem;
  }

  .ua-bookings {
    gap: 10px;
  }

  .ua-booking {
    grid-template-columns: auto 1fr;
    gap: 10px;
    padding: var(--bv-space-3);
  }

  .ua-booking__media {
    width: 48px;
    height: 48px;
  }

  .ua-booking__title {
    font-size: 0.8125rem;
    margin-bottom: 4px;
    overflow-wrap: anywhere;
    word-break: break-word;
  }

  .ua-booking__meta {
    gap: 4px 10px;
  }

  .ua-booking__meta li {
    font-size: 0.6875rem;
  }

  .ua-booking__price {
    font-size: 0.875rem;
  }

  .ua-badge {
    padding: 4px 8px;
    font-size: 0.6875rem;
  }

  .ua-booking__aside {
    grid-column: 1 / -1;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    gap: 8px 12px;
    width: 100%;
    padding-top: 8px;
    border-top: 1px solid var(--bv-line-soft);
  }

  .ua-booking__aside .ua-btn {
    margin-left: auto;
  }

  .ua-btn {
    gap: 6px;
    padding: 7px 12px;
    font-size: 0.75rem;
    font-weight: 600;
    line-height: 1.2;
  }

  .ua-btn--primary {
    padding: 7px 13px;
    font-size: 0.75rem;
    box-shadow: var(--bv-shadow-xs);
  }

  .ua-btn--primary:hover:not(:disabled) {
    transform: none;
  }

  .ua-btn--primary i {
    font-size: 0.7rem;
  }

  .ua-btn--ghost,
  .ua-btn--danger {
    padding: 7px 12px;
    font-size: 0.75rem;
  }

  .ua-btn--sm {
    padding: 5px 10px;
    font-size: 0.6875rem;
  }

  .ua-empty .ua-btn--primary {
    padding: 8px 14px;
  }

  .ua-empty {
    padding: var(--bv-space-6) var(--bv-space-3);
  }

  .ua-empty__icon {
    width: 44px;
    height: 44px;
    font-size: 1rem;
  }

  .ua-empty h3 {
    font-size: 0.9375rem;
  }

  .ua-empty p {
    font-size: 0.8125rem;
  }

  .ua-pagination {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  .ua-pagination__nav {
    justify-content: center;
  }

  .ua-profile {
    grid-template-columns: 1fr;
    gap: var(--bv-space-4);
  }

  .ua-avatar-upload {
    max-width: 220px;
    margin-inline: auto;
  }

  .ua-avatar-upload__preview {
    width: 96px;
    height: 96px;
    font-size: 1.6rem;
  }

  .ua-form-grid {
    grid-template-columns: 1fr;
    gap: var(--bv-space-3);
  }

  .ua-profile .react-select__control {
    min-height: 42px !important;
  }

  .ua-field label {
    font-size: 0.6875rem;
  }

  .ua-field input {
    padding: 10px 12px;
    font-size: 0.875rem;
  }

  .ua-form-section h3 {
    font-size: 0.9375rem;
    margin-bottom: var(--bv-space-3);
  }

  .ua-form-actions {
    justify-content: flex-end;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
  }

  .ua-form-actions .ua-btn {
    width: auto;
    max-width: 100%;
    padding: 7px 12px;
    font-size: 0.75rem;
  }
}

@media (max-width: 480px) {
  .ua-page {
    padding: 12px 0 var(--bv-space-6);
  }

  .ua-shell {
    gap: 10px;
  }

  .ua-sidebar {
    padding: 6px;
    border-radius: var(--bv-radius);
  }

  .ua-nav__link {
    padding: 8px 11px;
    font-size: 0.75rem;
    gap: 6px;
  }

  .ua-main__head {
    padding: var(--bv-space-2) 12px var(--bv-space-3);
  }

  .ua-main__titles h1 {
    font-size: 1.125rem;
  }

  .ua-main__titles p {
    font-size: 0.78rem;
  }

  .ua-card {
    padding: 12px;
  }

  .ua-card__head h2 {
    font-size: 0.9375rem;
  }

  .ua-stat__value {
    font-size: 1.125rem;
  }

  .ua-stats {
    grid-template-columns: 1fr;
  }

  .ua-filter {
    padding: 7px 10px;
    font-size: 0.75rem;
  }

  .ua-booking__media {
    width: 42px;
    height: 42px;
  }

  .ua-booking__title {
    font-size: 0.78rem;
  }

  .ua-booking__aside {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }

  .ua-booking__aside .ua-btn {
    margin-left: 0;
    width: auto;
    align-self: flex-start;
  }

  .ua-btn--primary {
    padding: 6px 11px;
    font-size: 0.72rem;
  }

  .ua-main__actions .ua-btn--primary,
  .ua-empty .ua-btn--primary {
    padding: 7px 12px;
  }

  .ua-form-actions .ua-btn {
    padding: 7px 11px;
    font-size: 0.72rem;
  }

  .ua-pagination__size {
    font-size: 0.8125rem;
  }

  .ua-pagination__page,
  .ua-pagination__btn {
    width: 32px;
    height: 32px;
    min-width: 32px;
    font-size: 0.8125rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/userAccount.css"],"names":[],"mappings":"AAAA;;qEAEqE;;AAErE;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,+CAA+C;EAC/C,gCAAgC;EAChC,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,mCAAmC;EACnC,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,0BAA0B;EAC1B,kCAAkC;EAClC,gBAAgB;EAChB,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,0BAA0B;EAC1B,kCAAkC;EAClC,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,WAAW;EACX,mCAAmC;EACnC,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,6BAA6B;EAC7B,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;EACrB;;;sCAGoC;AACtC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,2BAA2B;AAC7B;;AAEA,uBAAuB;AACvB;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,0BAA0B;EAC1B,kCAAkC;EAClC,gBAAgB;EAChB,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,gCAAgC;EAChC,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,kCAAkC;EAClC,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,4BAA4B;EAC5B,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,wCAAwC;EACxC,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,kCAAkC;EAClC,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,iBAAiB;EACjB,6BAA6B;EAC7B,+BAA+B;EAC/B,uBAAuB;EACvB,sBAAsB;EACtB,gCAAgC;EAChC,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf;;;sCAGoC;AACtC;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,mBAAmB;EACnB,0BAA0B;EAC1B,kCAAkC;EAClC,6BAA6B;EAC7B,qCAAqC;EACrC;;2CAEyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,4BAA4B;EAC5B,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;EAC9B,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,oCAAoC;EACpC,6BAA6B;EAC7B,mCAAmC;EACnC,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf;;;2CAGyC;EACzC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,4CAA4C;EAC5C,kBAAkB;EAClB,kCAAkC;EAClC,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,wCAAwC;EACxC,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,4BAA4B;EAC5B,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,4BAA4B;EAC5B,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gCAAgC;EAChC,gBAAgB;EAChB,gCAAgC;EAChC,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;EAClC,WAAW;EACX,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,0BAA0B;EAC1B,kCAAkC;EAClC,6BAA6B;EAC7B,iCAAiC;EACjC,eAAe;EACf;;2CAEyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,wCAAwC;EACxC,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,gCAAgC;EAChC,gBAAgB;EAChB,gCAAgC;EAChC,4BAA4B;EAC5B,oBAAoB;EACpB;;2CAEyC;AAC3C;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,0CAA0C;AAC5C;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,8BAA8B;EAC9B,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,SAAS;EACT,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,uCAAuC;EACvC,2BAA2B;EAC3B,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;EAC1C,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,8CAA8C;IAC9C,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,MAAM;IACN,kCAAkC;IAClC,+BAA+B;EACjC;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,iCAAiC;IACjC,QAAQ;IACR,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,QAAQ;IACR,oCAAoC;EACtC;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,sBAAsB;IACtB,8DAA8D;EAChE;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gDAAgD;IAChD,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;IAC1B,kCAAkC;EACpC;;EAEA;IACE,gCAAgC;IAChC,iCAAiC;IACjC,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,gDAAgD;IAChD,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,+BAA+B;IAC/B,SAAS;IACT,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;IAClB,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,2BAA2B;IAC3B,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,yCAAyC;EAC3C;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,+BAA+B;EACjC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;IACpB,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iCAAiC;EACnC;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,+BAA+B;EACjC;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,iDAAiD;EACnD;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,oBAAoB;EACtB;AACF","sourcesContent":["/* ================================================================\n   USER ACCOUNT — dashboard · bookings · profile\n   ================================================================ */\n\n.ua-page {\n  background: var(--bv-bg-cream);\n  min-height: calc(100vh - 72px);\n  padding: var(--bv-space-6) 0 var(--bv-space-10);\n  font-family: var(--bv-font-body);\n  color: var(--bv-ink-2);\n  width: 100%;\n  overflow-x: clip;\n}\n\n.ua-shell {\n  display: grid;\n  grid-template-columns: 260px minmax(0, 1fr);\n  gap: var(--bv-space-6);\n  align-items: start;\n  width: 100%;\n  min-width: 0;\n}\n\n/* —— Sidebar —— */\n.ua-sidebar {\n  position: sticky;\n  top: calc(72px + var(--bv-space-4));\n  display: flex;\n  flex-direction: column;\n  gap: var(--bv-space-4);\n  padding: var(--bv-space-4);\n  border-radius: var(--bv-radius-xl);\n  background: #fff;\n  border: 1px solid var(--bv-line-soft);\n  box-shadow: var(--bv-shadow-sm);\n}\n\n.ua-sidebar__profile {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: var(--bv-space-3);\n  border-radius: var(--bv-radius-lg);\n  background: var(--bv-bg-soft);\n  border: 1px solid var(--bv-line-soft);\n}\n\n.ua-sidebar__avatar {\n  flex-shrink: 0;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--bv-grad-primary);\n  color: #fff;\n  font-family: var(--bv-font-display);\n  font-size: var(--bv-text-sm);\n  font-weight: 700;\n}\n\n.ua-sidebar__avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.ua-sidebar__meta {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.ua-sidebar__meta strong {\n  font-size: var(--bv-text-sm);\n  font-weight: 700;\n  color: var(--bv-ink);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ua-sidebar__meta span {\n  font-size: var(--bv-text-xs);\n  color: var(--bv-muted);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ua-nav {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.ua-nav__link {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 11px 14px;\n  border-radius: var(--bv-radius);\n  border: 1px solid transparent;\n  color: var(--bv-ink-2);\n  font-size: var(--bv-text-sm);\n  font-weight: 600;\n  text-decoration: none;\n  transition:\n    background var(--bv-dur) var(--bv-ease),\n    border-color var(--bv-dur) var(--bv-ease),\n    color var(--bv-dur) var(--bv-ease);\n}\n\n.ua-nav__link i:first-child {\n  width: 18px;\n  text-align: center;\n  color: var(--bv-primary);\n  font-size: 0.9rem;\n}\n\n.ua-nav__chevron {\n  margin-left: auto;\n  font-size: 0.65rem;\n  color: var(--bv-primary-700);\n  opacity: 0.7;\n}\n\n.ua-nav__link:hover {\n  border-color: var(--bv-primary-line);\n  color: var(--bv-primary-800);\n}\n\n.ua-nav__link.is-active {\n  background: var(--bv-primary-50);\n  border-color: var(--bv-primary-line);\n  color: var(--bv-primary-800);\n  box-shadow: var(--bv-shadow-xs);\n}\n\n.ua-nav__link--accent {\n  margin-top: 4px;\n  background: var(--bv-grad-primary);\n  color: #fff;\n  box-shadow: var(--bv-shadow-teal);\n}\n\n.ua-nav__link--accent i:first-child {\n  color: #fff;\n}\n\n.ua-nav__link--accent:hover {\n  color: #fff;\n  transform: translateY(-1px);\n}\n\n/* —— Main content —— */\n.ua-main {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: var(--bv-space-5);\n}\n\n.ua-main__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: var(--bv-space-4);\n  flex-wrap: wrap;\n}\n\n.ua-main__titles h1 {\n  margin: 0 0 6px;\n  font-family: var(--bv-font-display);\n  font-size: var(--bv-text-2xl);\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  color: var(--bv-ink);\n  line-height: 1.15;\n}\n\n.ua-main__titles p {\n  margin: 0;\n  font-size: var(--bv-text-sm);\n  color: var(--bv-muted);\n  line-height: 1.5;\n}\n\n.ua-main__actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.ua-main__body {\n  display: flex;\n  flex-direction: column;\n  gap: var(--bv-space-5);\n}\n\n/* —— Cards & panels —— */\n.ua-card {\n  padding: var(--bv-space-5);\n  border-radius: var(--bv-radius-xl);\n  background: #fff;\n  border: 1px solid var(--bv-line-soft);\n  box-shadow: var(--bv-shadow-xs);\n}\n\n.ua-card__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: var(--bv-space-4);\n  padding-bottom: var(--bv-space-3);\n  border-bottom: 1px solid var(--bv-line-soft);\n}\n\n.ua-card__head h2 {\n  margin: 0 0 4px;\n  font-family: var(--bv-font-display);\n  font-size: var(--bv-text-lg);\n  font-weight: 800;\n  color: var(--bv-ink);\n  letter-spacing: -0.02em;\n}\n\n.ua-card__head p {\n  margin: 0;\n  font-size: var(--bv-text-sm);\n  color: var(--bv-muted);\n}\n\n/* —— Stats grid —— */\n.ua-stats {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: var(--bv-space-4);\n}\n\n.ua-stat {\n  display: flex;\n  align-items: center;\n  gap: var(--bv-space-4);\n  padding: var(--bv-space-4);\n  border-radius: var(--bv-radius-lg);\n  background: var(--bv-bg-soft);\n  border: 1px solid var(--bv-line-soft);\n}\n\n.ua-stat__body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.ua-stat__label {\n  display: block;\n  font-size: var(--bv-text-xs);\n  font-weight: 600;\n  color: var(--bv-muted);\n  margin-bottom: 4px;\n}\n\n.ua-stat__value {\n  display: block;\n  font-family: var(--bv-font-display);\n  font-size: var(--bv-text-xl);\n  font-weight: 800;\n  color: var(--bv-primary-800);\n  letter-spacing: -0.02em;\n  line-height: 1.1;\n}\n\n.ua-stat__icon {\n  flex-shrink: 0;\n  width: 44px;\n  height: 44px;\n  border-radius: var(--bv-radius);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--bv-primary-50);\n  border: 1px solid var(--bv-primary-line);\n  color: var(--bv-primary-700);\n  font-size: 1.1rem;\n}\n\n/* —— Filter tabs —— */\n.ua-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 4px;\n  border-radius: var(--bv-radius-lg);\n  background: var(--bv-bg-soft);\n  border: 1px solid var(--bv-line-soft);\n}\n\n.ua-filter {\n  flex: 1 1 auto;\n  min-width: fit-content;\n  padding: 9px 16px;\n  border: 1px solid transparent;\n  border-radius: var(--bv-radius);\n  background: transparent;\n  color: var(--bv-muted);\n  font-family: var(--bv-font-body);\n  font-size: var(--bv-text-sm);\n  font-weight: 600;\n  cursor: pointer;\n  transition:\n    background var(--bv-dur) var(--bv-ease),\n    border-color var(--bv-dur) var(--bv-ease),\n    color var(--bv-dur) var(--bv-ease);\n}\n\n.ua-filter:hover {\n  color: var(--bv-primary-800);\n  background: #fff;\n}\n\n.ua-filter.is-active {\n  background: #fff;\n  border-color: var(--bv-primary-line);\n  color: var(--bv-primary-800);\n  box-shadow: var(--bv-shadow-xs);\n}\n\n/* —— Booking list —— */\n.ua-bookings {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.ua-booking {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  gap: 14px;\n  align-items: center;\n  padding: var(--bv-space-4);\n  border-radius: var(--bv-radius-lg);\n  background: var(--bv-bg-soft);\n  border: 1px solid var(--bv-line-soft);\n  transition:\n    border-color var(--bv-dur) var(--bv-ease),\n    box-shadow var(--bv-dur) var(--bv-ease);\n}\n\n.ua-booking:hover {\n  border-color: var(--bv-primary-line);\n  box-shadow: var(--bv-shadow-xs);\n}\n\n.ua-booking__media {\n  width: 56px;\n  height: 56px;\n  border-radius: var(--bv-radius);\n  overflow: hidden;\n  flex-shrink: 0;\n  background: #fff;\n  border: 1px solid var(--bv-line-soft);\n}\n\n.ua-booking__media img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.ua-booking__media--placeholder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--bv-primary);\n  font-size: 1.25rem;\n}\n\n.ua-booking__body {\n  min-width: 0;\n}\n\n.ua-booking__title {\n  margin: 0 0 6px;\n  font-size: var(--bv-text-sm);\n  font-weight: 700;\n  color: var(--bv-ink);\n  line-height: 1.3;\n}\n\n.ua-booking__court {\n  font-weight: 600;\n  color: var(--bv-muted);\n}\n\n.ua-booking__meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px 14px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.ua-booking__meta li {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: var(--bv-text-xs);\n  color: var(--bv-muted);\n  font-weight: 500;\n}\n\n.ua-booking__meta i {\n  color: var(--bv-primary);\n  font-size: 0.7rem;\n}\n\n.ua-booking__aside {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.ua-booking__price {\n  font-family: var(--bv-font-display);\n  font-size: var(--bv-text-base);\n  font-weight: 800;\n  color: var(--bv-primary-800);\n  white-space: nowrap;\n}\n\n/* —— Status badge —— */\n.ua-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 5px 10px;\n  border-radius: var(--bv-radius-pill);\n  font-size: var(--bv-text-xs);\n  font-weight: 700;\n  line-height: 1;\n  white-space: nowrap;\n}\n\n.ua-badge--success {\n  background: #ecfdf5;\n  color: #047857;\n  border: 1px solid #a7f3d0;\n}\n\n.ua-badge--warning {\n  background: #fffbeb;\n  color: #b45309;\n  border: 1px solid #fde68a;\n}\n\n.ua-badge--danger {\n  background: #fef2f2;\n  color: #b91c1c;\n  border: 1px solid #fecaca;\n}\n\n.ua-badge--muted {\n  background: var(--bv-bg-soft);\n  color: var(--bv-muted);\n  border: 1px solid var(--bv-line);\n}\n\n/* —— Buttons —— */\n.ua-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 10px 18px;\n  border-radius: var(--bv-radius-pill);\n  border: 1px solid transparent;\n  font-family: var(--bv-font-display);\n  font-size: var(--bv-text-sm);\n  font-weight: 600;\n  cursor: pointer;\n  transition:\n    transform var(--bv-dur) var(--bv-ease),\n    box-shadow var(--bv-dur) var(--bv-ease),\n    background var(--bv-dur) var(--bv-ease);\n  text-decoration: none;\n  line-height: 1;\n}\n\n.ua-btn--primary {\n  background: var(--bv-grad-primary);\n  color: #fff;\n  box-shadow: var(--bv-shadow-teal);\n}\n\n.ua-btn--primary:hover:not(:disabled) {\n  transform: translateY(-1px);\n  color: #fff;\n}\n\n.ua-btn--ghost {\n  background: #fff;\n  border-color: var(--bv-line);\n  color: var(--bv-ink-2);\n}\n\n.ua-btn--ghost:hover:not(:disabled) {\n  border-color: var(--bv-primary-line);\n  color: var(--bv-primary-800);\n}\n\n.ua-btn--danger {\n  background: #fff;\n  border-color: #fecaca;\n  color: #b91c1c;\n}\n\n.ua-btn--danger:hover:not(:disabled) {\n  background: #fef2f2;\n}\n\n.ua-btn--sm {\n  padding: 7px 14px;\n  font-size: var(--bv-text-xs);\n}\n\n.ua-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* —— Empty state —— */\n.ua-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: var(--bv-space-8) var(--bv-space-4);\n  text-align: center;\n  border-radius: var(--bv-radius-lg);\n  background: var(--bv-bg-soft);\n  border: 1px dashed var(--bv-line);\n}\n\n.ua-empty__icon {\n  width: 52px;\n  height: 52px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--bv-primary-50);\n  border: 1px solid var(--bv-primary-line);\n  color: var(--bv-primary);\n  font-size: 1.25rem;\n}\n\n.ua-empty h3 {\n  margin: 0;\n  font-size: var(--bv-text-base);\n  font-weight: 700;\n  color: var(--bv-ink);\n}\n\n.ua-empty p {\n  margin: 0;\n  max-width: 36ch;\n  font-size: var(--bv-text-sm);\n  color: var(--bv-muted);\n  line-height: 1.5;\n}\n\n/* —— Pagination —— */\n.ua-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding-top: var(--bv-space-3);\n  border-top: 1px solid var(--bv-line-soft);\n}\n\n.ua-pagination__size {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: var(--bv-text-sm);\n  color: var(--bv-muted);\n  font-weight: 500;\n}\n\n.ua-pagination__size select {\n  padding: 7px 12px;\n  border-radius: var(--bv-radius);\n  border: 1px solid var(--bv-line);\n  background: #fff;\n  font-family: var(--bv-font-body);\n  font-size: var(--bv-text-sm);\n  color: var(--bv-ink-2);\n}\n\n.ua-pagination__nav {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.ua-pagination__page {\n  min-width: 36px;\n  height: 36px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background: var(--bv-grad-primary);\n  color: #fff;\n  font-size: var(--bv-text-sm);\n  font-weight: 700;\n}\n\n.ua-pagination__btn {\n  width: 36px;\n  height: 36px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  border: 1px solid var(--bv-line);\n  background: #fff;\n  color: var(--bv-ink-2);\n  cursor: pointer;\n  transition: border-color var(--bv-dur) var(--bv-ease);\n}\n\n.ua-pagination__btn:hover:not(:disabled) {\n  border-color: var(--bv-primary-line);\n  color: var(--bv-primary-800);\n}\n\n.ua-pagination__btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* —— Profile form —— */\n.ua-profile {\n  display: grid;\n  grid-template-columns: 200px minmax(0, 1fr);\n  gap: var(--bv-space-6);\n}\n\n.ua-avatar-upload {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  padding: var(--bv-space-4);\n  border-radius: var(--bv-radius-lg);\n  background: var(--bv-bg-soft);\n  border: 1px dashed var(--bv-line);\n  cursor: pointer;\n  transition:\n    border-color var(--bv-dur) var(--bv-ease),\n    background var(--bv-dur) var(--bv-ease);\n}\n\n.ua-avatar-upload:hover {\n  border-color: var(--bv-primary-line);\n  background: var(--bv-primary-50);\n}\n\n.ua-avatar-upload__preview {\n  width: 112px;\n  height: 112px;\n  border-radius: 50%;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #fff;\n  border: 2px solid var(--bv-primary-line);\n  color: var(--bv-primary);\n  font-size: 2rem;\n}\n\n.ua-avatar-upload__preview img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.ua-avatar-upload__hint {\n  margin: 0;\n  font-size: var(--bv-text-xs);\n  font-weight: 600;\n  color: var(--bv-muted);\n  text-align: center;\n}\n\n.ua-form-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: var(--bv-space-4);\n}\n\n.ua-form-grid--full {\n  grid-column: 1 / -1;\n}\n\n.ua-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n\n.ua-field label {\n  font-size: var(--bv-text-xs);\n  font-weight: 700;\n  color: var(--bv-ink-2);\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n}\n\n.ua-field input {\n  width: 100%;\n  padding: 11px 14px;\n  border-radius: var(--bv-radius);\n  border: 1px solid var(--bv-line);\n  background: #fff;\n  font-family: var(--bv-font-body);\n  font-size: var(--bv-text-sm);\n  color: var(--bv-ink);\n  transition:\n    border-color var(--bv-dur) var(--bv-ease),\n    box-shadow var(--bv-dur) var(--bv-ease);\n}\n\n.ua-field input:focus {\n  outline: none;\n  border-color: var(--bv-primary);\n  box-shadow: 0 0 0 3px var(--bv-primary-50);\n}\n\n.ua-field input:disabled {\n  background: var(--bv-bg-soft);\n  color: var(--bv-muted);\n  cursor: not-allowed;\n}\n\n.ua-field__error {\n  margin: 0;\n  font-size: var(--bv-text-xs);\n  color: var(--bv-danger);\n  font-weight: 500;\n}\n\n.ua-form-section {\n  grid-column: 1 / -1;\n  margin-top: var(--bv-space-2);\n  padding-top: var(--bv-space-4);\n  border-top: 1px solid var(--bv-line-soft);\n}\n\n.ua-form-section h3 {\n  margin: 0 0 var(--bv-space-4);\n  font-family: var(--bv-font-display);\n  font-size: var(--bv-text-base);\n  font-weight: 800;\n  color: var(--bv-ink);\n}\n\n.ua-form-actions {\n  grid-column: 1 / -1;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 10px;\n  padding-top: var(--bv-space-4);\n  border-top: 1px solid var(--bv-line-soft);\n}\n\n.ua-profile .react-select__control {\n  min-height: 44px !important;\n  border-radius: var(--bv-radius) !important;\n  border-color: var(--bv-line) !important;\n  background: #fff !important;\n  font-size: var(--bv-text-sm) !important;\n  box-shadow: none !important;\n}\n\n.ua-profile .react-select__control--is-focused {\n  border-color: var(--bv-primary) !important;\n  box-shadow: 0 0 0 3px var(--bv-primary-50) !important;\n}\n\n.ua-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: var(--bv-space-10);\n  color: var(--bv-muted);\n  font-size: var(--bv-text-sm);\n  font-weight: 500;\n}\n\n/* —— Responsive —— */\n@media (max-width: 1199px) {\n  .ua-form-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 991px) {\n  .ua-page {\n    padding: var(--bv-space-4) 0 var(--bv-space-7);\n    font-size: 0.875rem;\n    min-height: calc(100vh - 64px);\n  }\n\n  .ua-shell {\n    grid-template-columns: 1fr;\n    gap: var(--bv-space-3);\n    padding-inline: 0;\n  }\n\n  .ua-sidebar {\n    position: static;\n    min-height: 0;\n    max-width: 100%;\n    overflow: hidden;\n    padding: var(--bv-space-2);\n    gap: 0;\n    border-radius: var(--bv-radius-lg);\n    box-shadow: var(--bv-shadow-xs);\n  }\n\n  .ua-nav {\n    flex: unset;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    overflow-x: auto;\n    scrollbar-width: none;\n    -webkit-overflow-scrolling: touch;\n    gap: 6px;\n    max-width: 100%;\n    padding-bottom: 2px;\n  }\n\n  .ua-nav::-webkit-scrollbar {\n    display: none;\n  }\n\n  .ua-nav__link {\n    flex: 0 0 auto;\n    white-space: nowrap;\n    padding: 9px 12px;\n    font-size: 0.8125rem;\n    gap: 7px;\n    border-radius: var(--bv-radius-pill);\n  }\n\n  .ua-nav__link i:first-child {\n    font-size: 0.78rem;\n    width: 14px;\n  }\n\n  .ua-nav__chevron {\n    display: none;\n  }\n\n  .ua-nav__link--accent {\n    margin-top: 0;\n    padding-top: 9px;\n  }\n\n  .ua-sidebar__profile {\n    display: none;\n  }\n\n  .ua-main {\n    gap: var(--bv-space-3);\n  }\n\n  .ua-main__head {\n    flex-direction: column;\n    align-items: stretch;\n    gap: var(--bv-space-3);\n    padding: var(--bv-space-2) var(--bv-space-3) var(--bv-space-4);\n  }\n\n  .ua-main__titles h1 {\n    font-size: 1.25rem;\n    margin-bottom: 4px;\n  }\n\n  .ua-main__titles p {\n    font-size: 0.8125rem;\n    line-height: 1.45;\n  }\n\n  .ua-main__actions {\n    width: 100%;\n  }\n\n  .ua-main__actions .ua-btn {\n    width: auto;\n    max-width: 100%;\n    align-self: flex-start;\n  }\n\n  .ua-main__body {\n    gap: var(--bv-space-3);\n  }\n\n  .ua-stats {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: var(--bv-space-3);\n  }\n\n  .ua-stat {\n    padding: var(--bv-space-3);\n    gap: 10px;\n    align-items: center;\n  }\n\n  .ua-stat__body {\n    gap: 2px;\n  }\n\n  .ua-stat__icon {\n    width: 40px;\n    height: 40px;\n    font-size: 0.95rem;\n    flex-shrink: 0;\n  }\n\n  .ua-stat__value {\n    font-size: 1.25rem;\n  }\n\n  .ua-stat__label {\n    font-size: 0.6875rem;\n  }\n\n  .ua-card {\n    padding: var(--bv-space-4);\n    border-radius: var(--bv-radius-lg);\n  }\n\n  .ua-card__head {\n    margin-bottom: var(--bv-space-3);\n    padding-bottom: var(--bv-space-2);\n    flex-direction: column;\n    align-items: stretch;\n    gap: 10px;\n  }\n\n  .ua-card__head .ua-btn {\n    width: auto;\n    max-width: 100%;\n    align-self: flex-start;\n    justify-content: center;\n  }\n\n  .ua-card__head h2 {\n    font-size: 1rem;\n  }\n\n  .ua-card__head p {\n    font-size: 0.8125rem;\n  }\n\n  .ua-filters {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 6px;\n    padding: 4px;\n  }\n\n  .ua-filter {\n    flex: unset;\n    width: 100%;\n    min-width: 0;\n    text-align: center;\n    padding: 8px 10px;\n    font-size: 0.8125rem;\n  }\n\n  .ua-bookings {\n    gap: 10px;\n  }\n\n  .ua-booking {\n    grid-template-columns: auto 1fr;\n    gap: 10px;\n    padding: var(--bv-space-3);\n  }\n\n  .ua-booking__media {\n    width: 48px;\n    height: 48px;\n  }\n\n  .ua-booking__title {\n    font-size: 0.8125rem;\n    margin-bottom: 4px;\n    overflow-wrap: anywhere;\n    word-break: break-word;\n  }\n\n  .ua-booking__meta {\n    gap: 4px 10px;\n  }\n\n  .ua-booking__meta li {\n    font-size: 0.6875rem;\n  }\n\n  .ua-booking__price {\n    font-size: 0.875rem;\n  }\n\n  .ua-badge {\n    padding: 4px 8px;\n    font-size: 0.6875rem;\n  }\n\n  .ua-booking__aside {\n    grid-column: 1 / -1;\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 8px 12px;\n    width: 100%;\n    padding-top: 8px;\n    border-top: 1px solid var(--bv-line-soft);\n  }\n\n  .ua-booking__aside .ua-btn {\n    margin-left: auto;\n  }\n\n  .ua-btn {\n    gap: 6px;\n    padding: 7px 12px;\n    font-size: 0.75rem;\n    font-weight: 600;\n    line-height: 1.2;\n  }\n\n  .ua-btn--primary {\n    padding: 7px 13px;\n    font-size: 0.75rem;\n    box-shadow: var(--bv-shadow-xs);\n  }\n\n  .ua-btn--primary:hover:not(:disabled) {\n    transform: none;\n  }\n\n  .ua-btn--primary i {\n    font-size: 0.7rem;\n  }\n\n  .ua-btn--ghost,\n  .ua-btn--danger {\n    padding: 7px 12px;\n    font-size: 0.75rem;\n  }\n\n  .ua-btn--sm {\n    padding: 5px 10px;\n    font-size: 0.6875rem;\n  }\n\n  .ua-empty .ua-btn--primary {\n    padding: 8px 14px;\n  }\n\n  .ua-empty {\n    padding: var(--bv-space-6) var(--bv-space-3);\n  }\n\n  .ua-empty__icon {\n    width: 44px;\n    height: 44px;\n    font-size: 1rem;\n  }\n\n  .ua-empty h3 {\n    font-size: 0.9375rem;\n  }\n\n  .ua-empty p {\n    font-size: 0.8125rem;\n  }\n\n  .ua-pagination {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 10px;\n  }\n\n  .ua-pagination__nav {\n    justify-content: center;\n  }\n\n  .ua-profile {\n    grid-template-columns: 1fr;\n    gap: var(--bv-space-4);\n  }\n\n  .ua-avatar-upload {\n    max-width: 220px;\n    margin-inline: auto;\n  }\n\n  .ua-avatar-upload__preview {\n    width: 96px;\n    height: 96px;\n    font-size: 1.6rem;\n  }\n\n  .ua-form-grid {\n    grid-template-columns: 1fr;\n    gap: var(--bv-space-3);\n  }\n\n  .ua-profile .react-select__control {\n    min-height: 42px !important;\n  }\n\n  .ua-field label {\n    font-size: 0.6875rem;\n  }\n\n  .ua-field input {\n    padding: 10px 12px;\n    font-size: 0.875rem;\n  }\n\n  .ua-form-section h3 {\n    font-size: 0.9375rem;\n    margin-bottom: var(--bv-space-3);\n  }\n\n  .ua-form-actions {\n    justify-content: flex-end;\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 8px;\n  }\n\n  .ua-form-actions .ua-btn {\n    width: auto;\n    max-width: 100%;\n    padding: 7px 12px;\n    font-size: 0.75rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .ua-page {\n    padding: 12px 0 var(--bv-space-6);\n  }\n\n  .ua-shell {\n    gap: 10px;\n  }\n\n  .ua-sidebar {\n    padding: 6px;\n    border-radius: var(--bv-radius);\n  }\n\n  .ua-nav__link {\n    padding: 8px 11px;\n    font-size: 0.75rem;\n    gap: 6px;\n  }\n\n  .ua-main__head {\n    padding: var(--bv-space-2) 12px var(--bv-space-3);\n  }\n\n  .ua-main__titles h1 {\n    font-size: 1.125rem;\n  }\n\n  .ua-main__titles p {\n    font-size: 0.78rem;\n  }\n\n  .ua-card {\n    padding: 12px;\n  }\n\n  .ua-card__head h2 {\n    font-size: 0.9375rem;\n  }\n\n  .ua-stat__value {\n    font-size: 1.125rem;\n  }\n\n  .ua-stats {\n    grid-template-columns: 1fr;\n  }\n\n  .ua-filter {\n    padding: 7px 10px;\n    font-size: 0.75rem;\n  }\n\n  .ua-booking__media {\n    width: 42px;\n    height: 42px;\n  }\n\n  .ua-booking__title {\n    font-size: 0.78rem;\n  }\n\n  .ua-booking__aside {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 8px;\n  }\n\n  .ua-booking__aside .ua-btn {\n    margin-left: 0;\n    width: auto;\n    align-self: flex-start;\n  }\n\n  .ua-btn--primary {\n    padding: 6px 11px;\n    font-size: 0.72rem;\n  }\n\n  .ua-main__actions .ua-btn--primary,\n  .ua-empty .ua-btn--primary {\n    padding: 7px 12px;\n  }\n\n  .ua-form-actions .ua-btn {\n    padding: 7px 11px;\n    font-size: 0.72rem;\n  }\n\n  .ua-pagination__size {\n    font-size: 0.8125rem;\n  }\n\n  .ua-pagination__page,\n  .ua-pagination__btn {\n    width: 32px;\n    height: 32px;\n    min-width: 32px;\n    font-size: 0.8125rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
